import { Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { cloneElement, memo, type ReactElement } from "react";
import Questionnaire from "src/routes/_layout-nosidebar/questionnaire";

export const RequestAccessModal = memo(function RequestAccessModal({
    children,
}: {
    children: ReactElement;
}) {
    const [opened, { open, close }] = useDisclosure(false);

    const environment = import.meta.env.VITE_ENVIRONMENT;
    return (
        <>
            {cloneElement(children, { onClick: open } as React.HTMLAttributes<HTMLElement>)}
            <Modal opened={opened} onClose={close} title="Request Access" size="lg">
                <Questionnaire
                    heading_text={`Would you like to request access to Knowledge Search (${environment})?`}
                    paragraph_text="Please specify the knowledge bases that you need access to, an admin will review your request."
                    button_text="Request Access"
                    requesting_access={true}
                />
            </Modal>
        </>
    );
});
